import Axios from "axios";
import { Magic } from "magic-sdk";
import store from "..";
import config from "../../utils/config";
import { SET_BLOCKED, SIGN_OUT } from "../actions/actionTypes";
import { cleanCache } from "../../utils";
let prefix = "";
if (process.env.NODE_ENV === "qa") {
  prefix = "v1/";
}
const client = Axios.create({
  baseURL: `${config.app.apiUrl}/${prefix}payout`,
});

client.interceptors.response.use(
  (response) => {
    try {
      // const customHeaders = response.headers.getAll();
      const localVersion = localStorage.getItem("version");
      const version = response?.headers["x-api-version"];
      if (!localVersion) {
        // cleanCache(version);
        localStorage.setItem("version", version);
      } else if (version && localVersion && version !== localVersion) {
        cleanCache(version);
      }
      store.dispatch({
        type: SET_BLOCKED,
        payload: false,
      });
    } catch (err) {
      // console.log(err);
    }
    return response.data;
  },
  (error) => {
    if (error.code === "ERR_NETWORK") {
      const magic = new Magic(config.PK_MAGIC_LINK);
      magic.user.logout();
      store.dispatch({
        type: SIGN_OUT,
      });
    }
    // implement block screen
    if (error && error.response && error.response.data) {
      if (
        error.response.data.statusCode === 403 &&
        !window.location.href.includes("login")
      ) {
        // user blocked
        store.dispatch({
          type: SET_BLOCKED,
          payload: true,
        });
        const magic = new Magic(config.PK_MAGIC_LINK);
        magic.user.logout();
        setTimeout(() => {
          store.dispatch({
            type: SIGN_OUT,
          });
        }, 50000);
        throw error;
      }
      if (error.response.data.statusCode === 401) {
        const magic = new Magic(config.PK_MAGIC_LINK);
        magic.user.logout();
        store.dispatch({
          type: SIGN_OUT,
        });
      }
      // unknown errors 
      // if (error?.response?.data?.statusCode === 500) {
      //   store.dispatch({
      //     type: SHOW_MESSAGE,
      //     payload: {
      //       type: MESSAGE_BAR_TYPES.ERROR,
      //       message: error.response.data.message,
      //     },
      //   });
      // }
      // inititate block ui
    }
    // store.dispatch(Actions.showMessageBar(MESSAGE_BAR_TYPES.ERROR, error?.response?.data?.message || error.message))
    return Promise.reject(error);
  }
);
client.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state?.Auth?.tokens?.refresh;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export default client;
